var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"material-status"},[(_vm.value != 0)?_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('物料状态'))+":")]):_vm._e(),_c('div',{staticClass:"dot",class:'color-' + _vm.value})])}
var staticRenderFns = []

export { render, staticRenderFns }